// extracted by mini-css-extract-plugin
export var cardButton = "subCard-module--cardButton--58cc2";
export var tile = "subCard-module--tile--291f2";
export var tileContent = "subCard-module--tileContent--f5bc3";
export var tileIcon = "subCard-module--tileIcon--1bb12";
export var tileLinkArrow = "subCard-module--tileLinkArrow--57142";
export var tileOuter = "subCard-module--tileOuter--69915";
export var tileURL = "subCard-module--tileURL--28f4e";